import { gql } from '@apollo/client';

export const CHANGE_PASSWORD_MUTATION = gql`
  mutation changePassword($currentPassword: String, $newPassword: String, $timezone: Int) {
    changePassword(currentPassword: $currentPassword, newPassword: $newPassword, timezone: $timezone)
  }
`;

export const GET_ACCOUNT_QUERY = gql`
  query accountData {
    account: accountData {
      isSSOAuthenticated
    }
  }
`;
